import request from '@/utils/request2'

// 列表(主数据列表)
export function loadMaterialsListDataApi(data) {
  return request({
    url: 'tms-web/materials/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportMaterialsListDataApi(data) {
  return request({
    url: 'tms-web/materials/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveMaterialsApi(data) {
  return request({
    url: 'tms-web/materials/save',
    method: 'post',
    data
  })
}

// 变更状态
export function updateStatusMaterialsApi(data) {
  return request({
    url: 'tms-web/materials/updateStatus',
    method: 'post',
    data
  })
}

// 查看
export function viewMaterialsApi(data) {
  return request({
    url: 'tms-web/materials/view',
    method: 'post',
    data
  })
}

// 列表
export function listMaterialsApi(data) {
  return request({
    url: 'tms-web/materials/list',
    method: 'post',
    data
  })
}
